import { Group, Stack, Tabs, TabsProps } from '@mantine/core';
import React from 'react';
import { useHistory, useRouteMatch } from 'react-router';
import { useEffectOnce } from 'react-use';

import { TicketsTabKeyEnum } from './tickets.types';
import { TicketsList } from './TicketsList';

export function TicketsListWrapper() {
  const history = useHistory();

  const isAll = !!useRouteMatch({ path: '/tickets/all', exact: false });
  const isActive = !!useRouteMatch({ path: '/tickets/active', exact: false });

  const currTabKey = isAll ? TicketsTabKeyEnum.All : TicketsTabKeyEnum.Active;

  useEffectOnce(() => {
    if (!isActive && !isAll) {
      history.replace('/tickets/active');
    }
  });

  const onTabChange: TabsProps['onTabChange'] = (tabId) => {
    history.push(`/tickets/${tabId}`);
  };

  return (
    <Stack>
      <Group>
        <Tabs keepMounted={false} value={currTabKey} onTabChange={onTabChange}>
          <Tabs.List grow>
            <Tabs.Tab
              key={TicketsTabKeyEnum.Active}
              value={TicketsTabKeyEnum.Active}
              px={35}
            >
              Active Only
            </Tabs.Tab>

            <Tabs.Tab
              key={TicketsTabKeyEnum.All}
              value={TicketsTabKeyEnum.All}
              px={35}
            >
              All Tickets
            </Tabs.Tab>
          </Tabs.List>
        </Tabs>
      </Group>

      <TicketsList
        type={currTabKey}
        defaultFilters={
          isActive
            ? '?q[status_in][]=open&q[status_in][]=replied&q[status_in][]=review'
            : ''
        }
      />
    </Stack>
  );
}
